import { ResponseSuccess } from '@websolutespa/payload-utils/server';
import { PayloadHandler, PayloadRequest } from 'payload';
import { options } from '../options';
import { errorHandler } from './error.handler';

type BulkUploadResult = {
  filename: string;
  success: boolean;
  id?: string;
  error?: string;
};

type BulkUploadFile = {
  data: Buffer;
  mimetype: string;
  name: string;
  size: number;
};

export const bulkKbUploadHandler: PayloadHandler = async (req: PayloadRequest) => {
  try {

    const { llmApp, appTool } = req.data as { llmApp?: string, appTool?: string };
    if (!llmApp) {
      throw { status: 400, message: 'Bad Request: llmApp is required' };
    }

    // Access files from the request - Payload uses express-fileupload
    const reqFiles = (req as unknown as Record<string, unknown>).files as Record<string, BulkUploadFile | BulkUploadFile[]> | undefined;

    if (!reqFiles || Object.keys(reqFiles).length === 0) {
      throw { status: 400, message: 'Bad Request: No files uploaded' };
    }

    // req.files.files can be a single file or an array of files
    const rawFiles = reqFiles.files;
    const files: BulkUploadFile[] = Array.isArray(rawFiles) ? rawFiles : [rawFiles];

    const results: BulkUploadResult[] = [];

    for (const file of files) {
      try {
        const doc = await req.payload.create({
          collection: options.slug.llmKbFile,
          data: {
            isActive: true,
            llmApp: llmApp,
            ...(appTool ? { appTool } : {}),
          },
          overrideAccess: true,
          file: {
            data: file.data,
            mimetype: file.mimetype,
            name: file.name,
            size: file.size,
          },
        });

        results.push({
          filename: file.name,
          success: true,
          id: String(doc.id),
        });
      } catch (fileError: unknown) {
        results.push({
          filename: file.name,
          success: false,
          error: (fileError as Error).message || 'Unknown error',
        });
      }
    }

    const allSucceeded = results.every(r => r.success);
    const status = allSucceeded ? 200 : 207; // 207 Multi-Status if some failed

    return ResponseSuccess({
      results,
      totalFiles: files.length,
      successCount: results.filter(r => r.success).length,
      errorCount: results.filter(r => !r.success).length,
    }, { status });
  } catch (error: unknown) {
    return errorHandler(error);
  }
};
